<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo fila</span>
    </div>

    <div v-else-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        label="Descrição do botão"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo fila</span>
    </div>

    <v-select
      v-model="nodeDataLocale.filaId"
      :items="filas"
      item-text="nome"
      item-value="id"
      class="mt-2"
      label="Selecione uma fila *"
      no-data-text="Nenhuma fila encontrada"
      outlined
      clearable
      :rules="[validators.select]"
      @change="nodeConfig"
    ></v-select>

    <!-- ✅ NOVO CAMPO: MENSAGEM DE SUCESSO DO TICKET -->
    <v-textarea
      v-if="nodeDataLocale.filaId"
      v-model="nodeDataLocale.mensagemSucessoTicket"
      label="Mensagem de Sucesso do Ticket (Opcional)"
      placeholder="Ex: Seu protocolo é {PROTOCOLO}. Atendimento em até 72h úteis."
      outlined
      auto-grow
      rows="3"
      row-height="20"
      class="mt-2"
      counter="500"
      hint="Use {PROTOCOLO} como placeholder para o número do protocolo. Se não preenchida, será usada a mensagem padrão."
      persistent-hint
      :rules="[(v) => !v || v.length <= 500 || 'Máximo de 500 caracteres']"
      @change="nodeConfig"
    >
      <template #append>
        <v-tooltip bottom max-width="300">
          <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="info">
              mdi-information
            </v-icon>
          </template>
          <span>
            Esta mensagem será enviada ao cliente após a abertura do ticket.<br>
            <strong>Exemplo:</strong> "Seu número de protocolo é {PROTOCOLO}. 
            O atendimento poderá ocorrer em até 72 horas úteis."
          </span>
        </v-tooltip>
      </template>
    </v-textarea>

    <v-row>
      <v-col cols="auto">
        <v-checkbox
          v-model="nodeDataLocale.possuiHorarioAtendimento"
          label="Definir horário de atendimento?"
          @change="nodeConfig"
        ></v-checkbox>
      </v-col>

      <v-row
        v-if="nodeDataLocale.possuiHorarioAtendimento"
        class="mx-auto"
      >
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="nodeDataLocale.horarioAtendimentoInicio"
            v-mask="'##:##:##'"
            label="Horário inicial *"
            outlined
            dense
            prefix="Horário início:"
            hide-details="auto"
            placeholder="Tempo (hh:mm:ss)"
            validate-on-blur
            :rules="[validators.required]"
            @change="nodeConfig"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            v-model="nodeDataLocale.horarioAtendimentoFim"
            v-mask="'##:##:##'"
            label="Horário final *"
            outlined
            prefix="Horário fim:"
            dense
            hide-details="auto"
            placeholder="Tempo (hh:mm:ss)"
            validate-on-blur
            :rules="[validators.required]"
            @change="nodeConfig"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="12">
          <v-textarea
            v-if="nodeDataLocale.possuiHorarioAtendimento"
            v-model="nodeDataLocale.horarioAtendimentoMensagem"
            label="Mensagem informando horário de atendimento *"
            placeholder="Digite uma Mensagem"
            outlined
            auto-grow
            rows="1"
            row-height="15"
            validate-on-blur
            :rules="[validators.required]"
            @change="nodeConfig"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-row>

    <v-row>
      <v-col cols="auto">
        <v-checkbox
          v-model="atendimentoDiasDaSemana"
          label="Definir dias da semana de atendimento?"
          @change="nodeConfig"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row
      v-if="atendimentoDiasDaSemana"
      class="d-flex justify-center"
    >
      <v-col
        v-for="(dia, index) in diasDaSemana"
        :key="index"
        cols="auto"
        class="d-flex flex-wrap"
      >
        <v-switch
          v-model="nodeDataLocale.diasAtendimento"
          :label="dia.title"
          :value="dia.value"
          @change="nodeConfig"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="auto">
        <v-checkbox
          v-model="nodeDataLocale.atendimentoOffline"
          label="Atendimento Offline?"
          @change="nodeConfig"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-textarea
      v-if="nodeDataLocale.atendimentoOffline"
      v-model="nodeDataLocale.atendimentoOfflineMensagem"
      label="Mensagem Encerramento Offline *"
      placeholder="Digite uma Mensagem"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      @change="nodeConfig"
    ></v-textarea>
  </div>
</template>

<script>
import { inject, ref, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import FilaService from '@/services/modules/FilaService'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'

export default {
  props: {},

  setup(props, { emit }) {
    function nodeConfig() {
      emit('node-config')
    }

    const filas = ref([])

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    const atendimentoDiasDaSemana = ref(false)

    function checkDiasSemanaArray(array) {
      atendimentoDiasDaSemana.value = (array.diasAtendimento !== null && array.diasAtendimento.length > 0)
      if (array.diasAtendimento === null) array.diasAtendimento = []

      return array
    }

    watch(() => nodeData.value, async value => {
      nodeDataLocale.value = value
      checkDiasSemanaArray(nodeDataLocale.value)
      filas.value = await FilaService.getFilasCanalTipoBot()
    }, { immediate: true, deep: true })

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')
    watch(() => tipoIdPai.value, value => {
      tipoIdPaiLocale.value = value
    }, { immediate: true, deep: true })

    watch(() => atendimentoDiasDaSemana.value, value => {
      if (!value) nodeDataLocale.value.diasAtendimento = []
    }, { immediate: true, deep: true })

    const diasDaSemana = ref([
      { title: 'Domingo', value: 0 },
      { title: 'Segunda', value: 1 },
      { title: 'Terça', value: 2 },
      { title: 'Quarta', value: 3 },
      { title: 'Quinta', value: 4 },
      { title: 'Sexta', value: 5 },
      { title: 'Sábado', value: 6 },
    ])

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      filas,
      atendimentoDiasDaSemana,
      diasDaSemana,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
